import i18next from "i18next";
import { initReactI18next } from 'react-i18next';
import i18nFr from "./i18n-fr.json";
import i18nEn from "./i18n-en.json";
import i18nEs from "./i18n-es.json";
import i18nNl from "./i18n-nl.json";
import i18nDe from "./i18n-de.json";
import i18nIt from "./i18n-it.json";
import i18nPt from "./i18n-pt.json";
import i18nLightFr from "./i18n-light-fr.json";
import i18nLightEn from "./i18n-light-en.json";
import i18nLightDe from "./i18n-light-de.json";
import i18nLightIt from "./i18n-light-it.json";
import i18nLightEs from "./i18n-light-es.json";
import i18nLightNl from "./i18n-light-nl.json";
import i18nLightPt from "./i18n-light-pt.json";
import "moment/locale/fr";
import "moment/locale/es";
import countries from "i18n-iso-countries";
import moment from "moment";

i18next
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: { ...i18nFr.translation, ...i18nLightFr } },
      en: { translation: { ...i18nEn.translation, ...i18nLightEn } },
      de: { translation: { ...i18nDe.translation, ...i18nLightDe } },
      it: { translation: { ...i18nIt.translation, ...i18nLightIt } },
      es: { translation: { ...i18nEs.translation, ...i18nLightEs } },
      nl: { translation: { ...i18nNl.translation, ...i18nLightNl } },
      pt: { translation: { ...i18nPt.translation, ...i18nLightPt } }
    },
    fallbackLng: "en"
});

countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
countries.registerLocale(require("i18n-iso-countries/langs/it.json"));
countries.registerLocale(require("i18n-iso-countries/langs/pt.json"));
countries.registerLocale(require("i18n-iso-countries/langs/nl.json"));
countries.registerLocale(require("i18n-iso-countries/langs/es.json"));
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

moment.locale(i18next.language);

export default i18next;
